{
  "slug": "mensa-iq-requirements",
  "title": "Mensa IQ requirements explained",
  "description": "Learn how Mensa qualification uses the upper two percent, why qualifying numbers vary by test, and why online scores are not admission evidence.",
  "summary": "Mensa describes eligibility in percentile terms: a qualifying result must be at or above the 98th percentile on an approved, properly supervised intelligence test. The corresponding IQ number varies by scale.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "The requirement is a percentile, not one universal number",
      "paragraphs": [
        "Mensa International states that membership is open to people who score within the upper two percent of the general population on an approved intelligence test that was properly administered and supervised.",
        "The 98th percentile is often close to 130 on a mean-100, SD-15 scale, but other tests use different standard deviations, score types, and cutoffs. The accepted threshold must be checked for the specific test."
      ]
    },
    {
      "heading": "Ways to provide a qualifying result",
      "paragraphs": [
        "Depending on the national Mensa organization, a candidate may take an administered admission test or submit evidence from another approved assessment. Procedures, age restrictions, accepted instruments, and documentation vary by country.",
        "Keep the original professional score report. Contact the relevant Mensa office before arranging external testing if qualification is the purpose."
      ]
    },
    {
      "heading": "What practice and online tests can do",
      "paragraphs": [
        "Practice questions can help someone understand formats and timing. They do not prove eligibility, and repeated exposure may improve familiarity rather than measure a stable change in general ability.",
        "Mensa International states that online tests cannot be used for admission. Treat an online result as educational or indicative unless the receiving organization explicitly says otherwise."
      ]
    }
  ],
  "faqs": [
    {
      "question": "What IQ score do you need for Mensa?",
      "answer": "Eligibility is based on the 98th percentile on an approved supervised test. The equivalent number varies by test scale."
    },
    {
      "question": "Can I join Mensa with an online IQ result?",
      "answer": "Mensa International states that online tests cannot be used for admission."
    }
  ],
  "related": ["iq-test-vs-mensa-test", "what-is-considered-a-high-iq", "iq-percentiles"],
  "sources": [
    {
      "label": "Mensa International — getting your IQ tested",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
